<template>
    <div id="footer" class="n-footer-bg">
        <div class="n-footer">
            <div class="n-footer-con" v-if='!editContent'>
                <div class="n-footer-text">
                    <p>建议使用IE10以上浏览器 1024×768以上分辨率</p>
                    <p v-if="beian">
                        <a
                            href="http://beian.miit.gov.cn/"
                            style="color:#a0acb7;"
                            target="_blank"
                        >{{beian.number}}</a>
                        {{beian.company}}版权所有 © All rights reserved.
                    </p>
                </div>
            </div>
            <div style="color: #999;font-size: 14px;margin: 30px auto;" v-else v-html="editContent"></div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'bottom',
    data() {
        return {
            beian: null,
            beians: {
                gjychina: {
                    number: '京ICP备20007763号',
                    company: '北京工匠云科技有限公司'
                },
                yzspeixun: {
                    number: '京ICP备19027673号-2',
                    company: '北京云知识教育科技有限公司'
                },
                nmgrcpx: {
                    number: '京ICP备19027673号-5',
                    company: '北京云知识教育科技有限公司'
                }
            },
            platform: this.$store.getters.platform,
            editContent:''
        }
    },
    mounted() {},

    created() {
        this.view()
        this.footer()
    },
    methods: {
        view() {
            const domain = document.domain
            const split = domain.split('.')
            if (split.length > 2 && split[0] !== 'www') {
                return
            }
            let subdomain = split[split.length - 2]
            if (process.env.NODE_ENV == 'development') {
                subdomain = 'gjychina'
            }
            this.beian = this.beians[subdomain]
        },
        footer(){
            let id = this.platform.id
            this.$http
            .get(this.$cmsPath + '/platform/api/' + id)
            .then(function(res) {
                let editContent = res.body.data.agency
                this.editContent = editContent
            })
        }
    }
}
</script>
<style scoped>
@import '../assets/css/common.css';
</style>



// WEBPACK FOOTER //
// src/views/bottom.vue